import React from "react";
import { DocumentAdd, TrashCan, Close, FitToScreen, QueryQueue, Move, Download, ProgressBarRound, CircleFilled, Add, Erase, PlayFilledAlt, Stop, Package, WarningAlt, Search,
    Copy, Save, DocumentBlank, CheckmarkOutline,Image,VideoChat, DocumentAudio, TextAlignLeft, Help, Edit, Settings, Renew, ArrowDown, Pin, Screen, RuleDataQuality,
    SkipBack, SkipForward, Forward_10, Rewind_10, Home,SplitScreen,SidePanelOpen, SidePanelClose, OpenPanelFilledLeft, OpenPanelFilledRight, Timer, Send, Login, IbmCloudDirectLink_1Exchange,
    LogoFacebook, LogoTwitter, LogoYoutube, LogoInstagram, DnsServices, Minimize , ChevronRight, ChevronLeft, StopSignFilled, Rewind_5, Forward_5, FolderAdd ,
    UpToTop, PageFirst , PageLast, BookmarkAdd, VolumeUp, VolumeMuteFilled, InsertPage, Bookmark, ProgressBar, IbmPowerVs, FolderMoveTo, MessageQueue, Pause,
    CloudUpload, Upload, Globe, Network_3, TreeViewAlt,
} from '@carbon/icons-react'
import Series from "./CutomIcons/Series";
import Season from "./CutomIcons/Season";
import Clip from "./CutomIcons/Clip";

export const Icons = {
    new : DocumentAdd,
    delete: TrashCan,
    close: Close,
    fullscreen: FitToScreen,
    submit: QueryQueue,
    drag: Move,
    download: Download,
    copy: Copy,
    save: Save,
    file: DocumentBlank,
    check: CheckmarkOutline,
    loadingCircle: ProgressBarRound,
    edit: Edit,
    add: Add,
    erase: Erase,
    refresh: Renew,   
    loadItems: Package, 
    search: Search,

    stopService: Stop,
    restartService :Renew,
    
    dataQuality: RuleDataQuality,
    received: Login,
    timer: Timer,
    send: Send,
    synchronize: IbmCloudDirectLink_1Exchange,

    control_start: SidePanelClose ,
    control_end: SidePanelOpen  ,
    control_rewind_10: Rewind_10,
    control_forward_10: Forward_10,
    control_next: SkipForward,
    control_back: SkipBack,
    control_mark_in: OpenPanelFilledLeft,
    control_mark_out: OpenPanelFilledRight,
    control_split: SplitScreen,
    control_play: PlayFilledAlt,
    control_pause: Pause,
    
    marker_add: BookmarkAdd, 
    marker_in: PageFirst,
    marker_out: PageLast,
    marker_seg_add: InsertPage,
    marker_point: Bookmark ,
    marker_range: ProgressBar, 

    unmute: VolumeUp ,
    mute: VolumeMuteFilled ,

    playout_follow: ArrowDown,
    playout_fixed: Pin,

    image: Image,
    video: VideoChat,
    audio: DocumentAudio,
    text: TextAlignLeft,
    unknown: Help,
    settings: Settings,
    circle: CircleFilled,
    warning: WarningAlt,
    monitor: Screen,
    minimize: Minimize,

    series: Series,
    season: Season,
    clip: Clip,

    right: ChevronRight,
    left: ChevronLeft,
    today: StopSignFilled,

    website: DnsServices,
    facebook: LogoFacebook,
    twitter: LogoTwitter,
    instagram: LogoInstagram,
    youtube: LogoYoutube,
    back_5: Rewind_5,
    next_5: Forward_5,

    home: Home,
    oneGUI: IbmPowerVs,
    watchfolder: FolderMoveTo,
    fileQueuer: MessageQueue,
    ingest: CloudUpload,

    newFolder: FolderAdd,
    upload: Upload,
    remote: Globe,
    ftp: Network_3,
    tree: TreeViewAlt,

}

interface IconState
{
    type: keyof typeof Icons;
    size: number;
    color?: string;
    style?: React.CSSProperties;
}

export default function Icon({type, size, color, style} : IconState){
    if(!type) return <></>
    
    const renderIcon = () => {
        const SelIcon = Icons[type]
        return <SelIcon size={size} style={{...style, fill: color}} />
    }

    return <>{renderIcon()} </>
}
